import { Component, ViewChild } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { WorkersTimeRangesService } from '../_services/workers-time-ranges.service';
import { ConfirmationService, MessageService } from 'primeng/api';
import { firstValueFrom } from 'rxjs';
import { RxFormBuilder, RxFormGroup } from '@rxweb/reactive-form-validators';
import { FormValidatorService } from 'src/app/core/services/form-validator.service';
import { WorkerGuardShift } from '../_types/worker-guard-shift';
import { GuardsShiftsService } from '../../guards-shifts/_services/guards-shifts.service';
import { GuardShift } from '../../guards-shifts/_types/guard-shift';
import { WorkerGuardShiftsService } from '../_services/workers-guards-shifts.service';
import { IParamsCollection } from 'src/app/core/jsonapi/interfaces/params-collection';
import { TopbarService } from 'src/app/core/topbar/topbar.service';
import { LoginService } from '../../login/login.service';

@Component({
    selector: 'app-workers-guard-shift',
    templateUrl: './workers-guard-shift.component.html',
    styleUrls: ['./workers-guard-shift.component.scss'],
    standalone: false
})
export class WorkersGuardShiftComponent {
  public workerGuardShiftFormGroup!: RxFormGroup;

  public workerGuardShift: WorkerGuardShift = new WorkerGuardShift();

  public allowWrite: boolean = false;
  public allowDelete: boolean = false;
  public workerId: string = "";
  public guardShifts: GuardShift[] = [];

  constructor(
    private config: DynamicDialogConfig,
    private workerGuardShiftsService: WorkerGuardShiftsService,
    private messageService: MessageService,
    private dynamicDialogRef: DynamicDialogRef,
    private formBuilder: RxFormBuilder,
    private formValidationService: FormValidatorService,
    private guardShiftsService: GuardsShiftsService,
    private topbarService: TopbarService,
    private loginService: LoginService
  ) {
    

    this.workerGuardShiftFormGroup = this.formBuilder.formGroup<WorkerGuardShift>(this.workerGuardShift) as RxFormGroup;
  }


  ngOnInit(): void {
    this.workerGuardShift.workerId = this.config.data.workerId;
    
    this.allowWrite = this.loginService.hasPermission("WORKERS.WRITE");
    this.allowDelete = this.loginService.hasPermission("WORKERS.DELETE");
    this.loadGuardShift();
  }

  async loadGuardShift(){
    let params:IParamsCollection = {
      sort: ['name']
    };
    let response = await firstValueFrom(this.guardShiftsService.all(params));
    this.guardShifts = response.data;
  }

  async save() {
    let valid = this.formValidationService.validateForm(this.workerGuardShiftFormGroup);
    if (valid) {
      this.workerGuardShift = Object.assign(this.workerGuardShift, this.workerGuardShiftFormGroup.value);            
      await this.workerGuardShiftsService.save(this.workerGuardShift).subscribe({
        next: (data) => {
          this.messageService.add({ closable: true, severity: 'success', detail: "Turno de guardia añadido correctamente" });
          this.dynamicDialogRef.close();
        },
        error: (error) => {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error al asignar el turno de guardia' });
        }
      });
    }
  }

  cancel() {
    this.dynamicDialogRef.close();
  }

}
